import Event from './Event.container';

export default Event;
